/*!
    * @product/scmp-sdk 1.1.36
    * built by undefined
  */
import{i as t}from"./chunk-77U5PEFI.js";var r=()=>{let{acquisition:{getPersonalizationByExperimentId:e,getVariantByExperimentId:i,uiTestingState:o}}=t();return{getPersonalizationByExperimentId:e,getVariantByExperimentId:i,uiTestingState:o}};export{r as a};
//# sourceMappingURL=chunk-PW4NGGDV.js.map
